<template>
    <!--
          作者：4948286@qq.com
          时间：2019-10-30
          描述：图片上传
      -->
    <div class="upload-wrap">
        <el-dialog :title="$t('文件管理')" :visible.sync="dialogVisible" :close-on-click-modal="false"
            custom-class="upload-dialog" :close-on-press-escape="false" @close="cancelFunc" :width="dialogWidth"
            :append-to-body="true">
            <div class="upload-wrap-inline mb16 clearfix">
                <div class="leval-item">
                    <el-button size="small" icon="el-icon-plus" @click="addCategory">{{ $t('添加分类') }}</el-button>
                    <el-popover placement="bottom" width="200" trigger="click" :value="true">
                        <ul class="move-type">
                            <li v-for="(item, index) in typeList" :key="index" @click="moveTypeFunc(item.group_id)">
                                {{ item.group_name }}
                            </li>
                        </ul>
                        <el-button size="small" slot="reference" icon="el-icon-caret-bottom">{{ $t('移动至') }}</el-button>
                    </el-popover>
                    <el-button size="small" type="danger" icon="el-icon-delete" @click="deleteFileFunc(false)">
                        {{ $t('批量删除') }}
                    </el-button>
                </div>
                <div class="leval-item upload-btn">
                    <el-upload class="uploader" ref="uploader" :show-file-list="false" :multiple="true" :limit="99"
                        action="string" accept="image/jpeg,image/png,image/jpg" :on-change="fileChange"
                        :before-upload="onBeforeUploadImage">
                        <el-button size="small" icon="el-icon-upload" type="primary">{{ $t('点击上传') }}</el-button>
                    </el-upload>
                </div>
            </div>
            <!--我的资源库-->
            <div class="fileContainer">
                <div class="file-type">
                    <ul>
                        <li :class="activeType == item.group_id ? 'item active' : 'item'" v-for="(item, index) in typeList"
                            :key="index" @click="selectTypeFunc(item.group_id)">
                            {{ item.group_name }}
                            <div class="operation" @click.stop v-if="item.group_id != null">
                                <p @click="editCategoryFunc(item)"><i class="el-icon-edit"></i></p>
                                <p @click="deleteCategoryFunc(item.group_id)"><i class="el-icon-delete"></i></p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="file-content">
                    <ul class="fileContainerUI clearfix">
                        <li class="file" v-for="(item, index) in fileList.data" :key="index"
                            @click="selectFileFunc(item, index)">
                            <div v-if="item.selected == true" class="selectedIcon"><i class="el-icon-check"></i></div>
                            <img :scr="item.file_path" :style="'background-image:url(' + item.file_path + ')'" alt="" />
                            <p class="desc">{{ getProcessedName(item) }}</p>
                            <div class="bottom-shade" @click.stop>
                                <a href="javascript:void(0)" @click="deleteFileFunc(item)"><i
                                        class="el-icon-delete"></i></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!--分页-->
            <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                    :page-sizes="[12, 24, 36, 42, 48]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="cancelFunc">{{ $t('取 消') }}</el-button>
                <el-button size="small" type="primary" @click="confirmFunc">{{ $t('确 定') }}</el-button>
            </div>

            <!-- 图片裁切 -->
            <el-dialog width="940px" class="image-cropper-dialog" :visible.sync="cropperDialogVisible"
                :before-close="cropperClosed" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
                <img :src="item.file" :title="item.name" v-for="(item, index) in filelistUpload" :key="index + '-img'"
                    :class="[index === fileShowIndx ? 'show' : '']" class="corpper-img" style="display:inline-block;"
                    width="60" height="60" @click="fileCropperChange(fileShowIndx, index)">
                <!-- 裁切组件 -->
                <template v-for="(item, index) in filelistUpload">
                    <sc-cropper v-if="fileShowIndx === index" :key="index + '-file'" :src="item.file"
                        :aspectRatio="isAspectRatio ? item.width / item.height : 1" :ref="`cropper-${index}`"
                        :class="`cropper-${index}`" />
                </template>
                <template #footer>
                    <el-button @click="cropperClosed()">{{ $t('取 消') }}</el-button>
                    <el-button type="primary" @click="onConfirm">{{ $t('确 定') }}</el-button>
                </template>
            </el-dialog>
        </el-dialog>


        <!--图片类别-->
        <AddCategory v-if="isShowCategory" :category="category" @closeCategory="closeCategoryFunc"></AddCategory>
    </div>
</template>

<script>
import FileApi from '@/api/file.js';
import Cropper from 'cropperjs'
import AddCategory from './part/AddCategory'
// import ImageCropperModal from '@/components/imageCropper/Cropper'
import scCropper from '@/components/scCropper/index'

export default {
    components: {
        AddCategory,
        scCropper
    },
    props: {
        config: {
            type: Object,
            default: () => ({})
        },
        // 控制切图 是否为正方形
        isAspectRatio: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            resetCrop: false,
            blobUrl: '',
            /*宽度*/
            dialogWidth: '910px',
            /*类别*/
            activeType: null,
            /*图片类别*/
            typeList: [],
            /*图标路径*/
            imageUrl: null,
            /*弹窗显示*/
            dialogVisible: true,
            /*文件列表*/
            fileList: [],
            /*分类添加loading*/
            addLoading: false,
            /*默认值*/
            this_config: {
                /*上传个数*/
                total: 1
            },
            /*记录选中的个数*/
            record: 0,
            /*是否加载完成*/
            loading: true,
            /*列表数据*/
            tableData: [],
            /*一页多少条*/
            pageSize: 36,
            /*一共多少条数据*/
            totalDataNumber: 0,
            /*当前是第几页*/
            curPage: 1,
            /*是否显示图片类别编辑框*/
            isShowCategory: false,
            /*当前类别model*/
            category: null,
            /*选中图片*/
            fileIds: [],
            // fileName: '', // 存放文件名
            // file: null,
            filelistUpload: [],
            fileShowIndx: 0,
            cropperDialogVisible: false,
        };
    },
    created() {
        /*覆盖默认值*/
        if (Object.prototype.toString.call(this.config).toLowerCase() === '[object object]') {
            for (let key in this.config) {
                this.this_config[key] = this.config[key];
            }
        }
        this.getFileCategory();
        this.getData();

    },
    methods: {
        getProcessedName(item) {
            if (item.storage === 'ai') {
                const index = item.real_name.indexOf('/');
                if (index !== -1) {
                    return item.real_name.slice(index + 1);
                }
            }
            return item.real_name;
        },
        /*获取图片类别*/
        getFileCategory() {
            let self = this;
            let param = {}
            FileApi.fileCategory(param, true)
                .then(data => {
                    let type = [{
                        group_id: null,
                        group_name: '全部'
                    }];
                    self.typeList = type.concat(data.data.group_list);
                })
                .catch(error => {
                    self.loading = false;
                });
        },
        /*添加图片类别*/
        addCategory() {
            this.isShowCategory = true;
        },
        /*修改类别*/
        editCategoryFunc(item) {
            this.isShowCategory = true;
            this.category = item;
        },
        /*关闭类别层*/
        closeCategoryFunc(e) {
            if (e != null) {
                this.getFileCategory();
            }
            this.isShowCategory = false;
        },
        /*删除类别提示*/
        deleteCategoryFunc(e) {
            let self = this
            self.$confirm(self.$t('此操作将永久删除该记录, 是否继续?'), self.$t('提示'), {
                confirmButtonText: self.$t('确定'),
                cancelButtonText: self.$t('取消'),
                type: 'warning'
            }).then(() => {
                this.deleteCategory(e);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: self.$t('已取消删除')
                });
            });
        },
        /*删除类别*/
        deleteCategory(e) {
            let self = this;
            FileApi.deleteCategory({
                group_id: e
            },).then(data => {
                self.$message({
                    message: self.$t('删除成功'),
                    type: 'success'
                });
                self.getFileCategory();
            })
                .catch(error => {
                    self.$message.error('删除失败');
                });
        },
        /*选择类别*/
        selectTypeFunc(id) {
            this.activeType = id;
            this.curPage = 1;
            this.getData();
        },
        /*选择第几页*/
        handleCurrentChange(val) {
            this.curPage = val;
            this.getData();
        },
        /*每页多少条*/
        handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getData();
        },
        /*获取图片列表数据*/
        getData: function () {
            let self = this;
            let param = {
                page: self.curPage,
                pageSize: self.pageSize,
                group_id: self.activeType
            }
            FileApi.fileList(param, true).then(data => {
                self.loading = false;
                self.fileList = data.data.file_list;
                self.totalDataNumber = self.fileList.total;
            })
                .catch(error => {
                    self.loading = false;
                });
        },
        /*图片移动到某个类别*/
        moveTypeFunc(e) {
            let self = this;
            let fileIds = [];
            self.fileList.data.forEach(item => {
                if (item.selected) {
                    fileIds.push(item.file_id);
                }
            });
            if (fileIds.length == 0) {
                self.$message({
                    message: '请选择文件',
                    type: 'warning'
                });
                return;
            }
            self.$confirm('确定移动选中的文件吗？, 是否继续?', self.$t('提示'), {
                confirmButtonText: self.$t('确定'),
                cancelButtonText: self.$t('取消'),
                type: 'warning'
            }).then(() => {
                FileApi.moveFile({
                    group_id: e,
                    fileIds: fileIds,
                }, true).then(data => {
                    self.$message({
                        message: '移动成功',
                        type: 'success'
                    });
                    self.getFileCategory();
                    self.getData();
                }).catch(error => {
                });
            }).catch(() => {

            });
        },
        // 图片裁切
        getCropperImg(img, aspectRatio = 1, fileName = 'fileName.jpg', type = 'image/jpeg') {
            return new Promise((resolve) => {
                const crop = new Cropper(img, {
                    viewMode: 2,
                    dragMode: 'move',
                    responsive: false,
                    aspectRatio: aspectRatio, // 裁切宽高比
                    autoCropArea: 1, // 自动裁切区域大小 0~1
                    minCropBoxWidth: 200, // 最小裁切宽度
                    minCropBoxHeight: 200, // 最小裁切高度
                    ready() {
                        crop.getCroppedCanvas().toBlob((blob) => {
                            let file = new File([blob], fileName, { type: type })
                            resolve(file)
                        }, type)
                    },
                },
                );
                crop.setCropBoxData({
                    width: 600,
                    height: 600
                })
            })

        },
        /*选择上传图片*/
        fileChange(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img == 'jpg' || img == 'png' || img == 'jpeg'
            if (!suffix) {
                this.$message.error(this.$t('只能上传图片！'))
                return false
            }
            const isContinue = this.onBeforeUploadImage(file)
            // 大于2M图片不展示
            if (!isContinue) {
                return false
            }
            const reader = new FileReader()
            reader.onload = (e) => {
                // 把Array Buffer转化为blob 如果是base64不需要
                // this.file = (typeof e.target.result) === 'object' ? window.URL.createObjectURL(new Blob([e.target.result])) : e.target.result
                const fileSrc = (typeof e.target.result) === 'object' ? window.URL.createObjectURL(new Blob([e.target.result])) : e.target.result

                const image = new Image();
                image.src = fileSrc;
                image.onload = () => {
                    const divPar = document.createElement('DIV')
                    divPar.appendChild(image)
                    const fileItem = {
                        file: fileSrc,
                        uploadFile: undefined,
                        width: image.width,
                        height: image.height,
                        name: file.name,
                        uid: file.uid,
                        type: (file.raw && file.raw.type) || ''
                    }
                    const aspectRatio = this.isAspectRatio ? image.width / image.height : 1;

                    this.getCropperImg(image, aspectRatio, fileItem.name, fileItem.type).then(fileCropper => {

                        const form = new FormData()
                        form.append('iFile', fileCropper)
                        form.append('group_id', this.activeType)
                        fileItem.uploadFile = form;

                        const target = this.filelistUpload.find(item => item.uid === fileItem.uid)
                        if (!target) {
                            this.filelistUpload.push(fileItem)
                        }
                        this.cropperDialogVisible = true
                        this.fileShowIndx = 0
                    })
                }
            }
            // 转化为base64
            reader.readAsArrayBuffer(file.raw)
        },
        cropperClosed() {
            this.cropperDialogVisible = false
            // this.file = null
            this.filelistUpload = []
            // this.fileName = ''
            this.getData();
        },
        /*选择图片之前*/
        onBeforeUploadImage(file) {
            const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
            const isLt1M = file.size / 1024 / 1024 < 2;
            if (!isIMAGE) {
                this.$message.error(this.$t('上传文件只能是图片格式!'));
            }
            if (!isLt1M) {
                this.$message.error(this.$t('上传文件大小不能超过 2MB!'));
            }
            return isIMAGE && isLt1M;
        },
        // 切换裁切组件，处理数据并做存储
        fileCropperChange(oldIndex, index) {
            return new Promise((resolve, reject) => {
                // 获取当前结果，并存储起来
                let self = this
                const { name, type } = self.filelistUpload[oldIndex]
                self.$refs[`cropper-${oldIndex}`][0].getCropFile(file => {
                    const form = new FormData()
                    file.uid = Date.now()
                    form.append('iFile', file)
                    form.append('group_id', self.activeType)
                    // 存储
                    self.$set(self.filelistUpload[oldIndex], 'uploadFile', form)
                    setTimeout(() => {
                        self.fileShowIndx = index
                        resolve()
                    })
                }, name, type)
            })
        },
        // 点击剪裁弹框的确定按钮
        async onConfirm() {
            // 处理当前展示img,裁切取值
            await this.fileCropperChange(this.fileShowIndx, this.fileShowIndx)
            const fileUploads = this.filelistUpload
            const target = this.filelistUpload.find(item => !item.uploadFile)
            if (target) {
                this.$message({
                    message: this.$t('请查看/裁切其它上传图片!'),
                    type: 'warning'
                });
                return
            }
            const loading = this.$loading({
                lock: true,
                text: this.$t('图片上传中,请等待'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            for (let i = 0; i < fileUploads.length; i++) {
                const form = fileUploads[i].uploadFile
                try {
                    await FileApi.uploadFile(form)
                } catch (error) {
                    this.$message({
                        message: this.$t('当前图片上传失败!'),
                        type: 'warning'
                    });
                }
            }
            loading.close();
            // 关闭弹框，清除数据
            this.cropperClosed()
        },
        /*上传图片*/
        UploadImage(param) {
            let self = this;
            const loading = this.$loading({
                lock: true,
                text: self.$t('图片上传中,请等待'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData();
            formData.append('iFile', param.file);
            formData.append("group_id", self.activeType);
            FileApi.uploadFile(formData).then(() => {
                loading.close();
                self.getData();
                param.onSuccess(); // 上传成功的图片会显示绿色的对勾
                // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
            }).catch(() => {
                loading.close();
                self.$message({
                    message: self.$t('本次上传图片失败'),
                    type: 'warning'
                });
                param.onError();
            });
        },
        /*选择图片*/
        selectFileFunc(item, index) {
            if (item.selected) {
                item.selected = false;
                this.record--;
            } else {
                item.selected = true;
                this.record++;
                /* if (this.record >= this.this_config.total) {
                  this.$message({
                    message: '本次最多只能上传 ' + this.this_config.total + ' 个文件',
                    type: 'warning'
                  });
                  return;
                } else {
                  item.selected = true;
                  this.record++;
                } */
            }
            this.$set(this.fileList.data, index, item);
        },
        /*删除图片*/
        deleteFileFunc(e) {
            let self = this;
            let loading;
            self.$confirm(self.$t('此操作将永久删除该记录, 是否继续?'), self.$t('提示'), {
                confirmButtonText: self.$t('确定'),
                cancelButtonText: self.$t('取消'),
                type: 'warning'
            }).then(() => {
                loading = self.$loading({
                    lock: true,
                    text: self.$t('正在删除'),
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let temp_list = [];
                if (e) {
                    temp_list.push(e.file_id);
                } else {
                    for (let i = 0; i < self.fileList.data.length; i++) {
                        let item = self.fileList.data[i];
                        if (item.selected) {
                            temp_list.push(item.file_id);
                        }
                    }
                }
                FileApi.deleteFiles({
                    fileIds: temp_list
                }, true)
                    .then(data => {
                        loading.close();
                        self.$message({
                            message: self.$t('删除成功'),
                            type: 'success'
                        });
                        self.getData();
                    })
                    .catch(error => {
                        loading.close();
                    });
            }).catch(() => {
                loading.close();
                self.$message({
                    message: self.$t('删除失败'),
                    type: 'warning'
                });
            });
        },
        /*选择图片确认*/
        confirmFunc() {
            let self = this
            if (this.record > 1) {
                this.$message({
                    message: self.$t('本次最多只能上传1个文件'),
                    type: 'warning'
                });
                return;
            }
            let list = [];
            let leng = 0;
            for (let i = 0; i < this.fileList.data.length; i++) {
                let item = this.fileList.data[i];
                if (item.selected) {
                    let obj = {
                        file_id: item.file_id,
                        file_path: item.file_path
                    }
                    list.push(obj);
                    leng++;
                }
                if (leng > this.this_config.total) {
                    break;
                }
            }
            this.$emit('returnImgs', list);
        },
        /*取消*/
        cancelFunc() {
            this.$emit('returnImgs', null);
        }
    }
};
</script>

<style lang="scss">
.el-message.el-message--error {
    z-index: 9999 !important;
}

.image-cropper-dialog {
    .vue-cropper {
        height: 600px;
    }

    .corpper-img {
        padding: 6px;
        border-radius: 4px;
        cursor: pointer;

        &.show {
            background: #c6e2ff;
        }
    }
}

.upload-dialog .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
}

.upload-wrap-inline .leval-item {
    display: inline-block;
}

.upload-wrap-inline .upload-btn {
    float: right;
}

.fileContainer {
    position: relative;
    padding-left: 120px;
}

.fileContainer .file-type {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    overflow-y: auto;
    width: 120px;
}

.fileContainer .file-type li {
    padding: 10px 0;
    cursor: pointer;
    text-align: center;
    padding-right: 20px;
    min-height: 20px;
    position: relative;
}

.fileContainer .file-type li.active {
    background: #b4b4b4;
    color: #FFFFFF
}

.fileContainer .file-type li .operation {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 20px;
}

.fileContainer .file-type li:hover .operation {
    display: block;
}

.fileContainer .file-content {
    height: 300px;
    text-align: center;
    overflow: hidden;
    padding: 10px;
    margin: 0;
    overflow-y: auto;
    border: 1px solid #c6c6c6;
}

.fileContainer li.file {
    float: left;
    margin: 10px 9px 0px;
    position: relative;
    width: 100px;
}

.fileContainer li.file img {
    display: inline-block;
    width: 100px;
    height: 100px;
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;
}

.fileContainer li.file p.desc {
    font-size: 12px;
    height: 15px;
    line-height: 15px;
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
}

.fileContainer li.file:hover .bottom-shade {
    display: block;
}

.fileContainer .bottom-shade {
    position: absolute;
    bottom: 16px;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    height: 26px;
    line-height: 26px;
    width: 100%;
    display: none;
    transform: all 0.2s ease-out 0s;
    color: #FFFFFF;
}

.fileContainer .bottom-shade a {
    color: #FFFFFF;
}

.fileContainer .selectedIcon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    background: #ff9900;
    z-index: 1;
    color: #FFFFFF;
    cursor: pointer;
}

// :focus {
//   outline: -webkit-focus-ring-color auto 1px;
// }

.upload-dialog .pagination-wrap {
    margin-top: 16px;
    text-align: right;
}

.move-type {
    max-height: 200px;
    overflow-y: auto;
}

.move-type li {
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
}

.move-type li:hover {
    background: #c6e2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Upload.vue